// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Card_Wrapper__ovqkU {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 160px;
  padding: 20px;
  width: 90%;
  position: relative;
  background-color: #ffffff;
  border: 2px solid #d9dce0;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  border-radius: 10px;
  overflow: hidden;
}
.Card_Wrapper__ovqkU:hover {
  cursor: pointer;
  border: 2px solid #5f6d7e;
  transition: border 200ms ease-in-out;
}
.Card_leftSide__DsdQw {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  padding-left: 12px;
}
.Card_rightSide__QQOC2 {
  position: absolute;
  right: -210px;
  top: -83px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  overflow: hidden;
}
.Card_backgroundImage__U3mjM {
  width: 384px;
  height: 384px;
}
.Card_rightSide__QQOC2,
.Card_icon__PQQjh {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.Card_icon__PQQjh {
  width: 24px;
  height: 24px;
}
.Card_divider__CbVlc {
  background-color: #5f6d7e;
  height: 2px;
  width: 40px;
}
.Card_title__b9K09 {
  display: flex;
  align-items: center;
  gap: 16px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  text-transform: uppercase;
  z-index: 10;
}

@media screen and (max-width: 1105px) {
  .Card_Wrapper__ovqkU {
    width: 100%;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 500px) {
  .Card_title__b9K09 {
    font-size: 16px;
    line-height: 20px;
    gap: 5px;
  }
  .Card_backgroundImage__U3mjM {
    width: 350px;
    height: 350px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/dashboard/components/PolaznikCard/Card.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".Wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 160px;\n  padding: 20px;\n  width: 90%;\n  position: relative;\n  background-color: #ffffff;\n  border: 2px solid #d9dce0;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.Wrapper:hover {\n  cursor: pointer;\n  border: 2px solid #5f6d7e;\n  transition: border 200ms ease-in-out;\n}\n.leftSide {\n  display: flex;\n  align-items: baseline;\n  flex-direction: column;\n  justify-content: center;\n  gap: 24px;\n  padding-left: 12px;\n}\n.rightSide {\n  position: absolute;\n  right: -210px;\n  top: -83px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  overflow: hidden;\n}\n.backgroundImage {\n  width: 384px;\n  height: 384px;\n}\n.rightSide,\n.icon {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n.icon {\n  width: 24px;\n  height: 24px;\n}\n.divider {\n  background-color: #5f6d7e;\n  height: 2px;\n  width: 40px;\n}\n.title {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  text-transform: uppercase;\n  z-index: 10;\n}\n\n@media screen and (max-width: 1105px) {\n  .Wrapper {\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .title {\n    font-size: 16px;\n    line-height: 20px;\n    gap: 5px;\n  }\n  .backgroundImage {\n    width: 350px;\n    height: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": `Card_Wrapper__ovqkU`,
	"leftSide": `Card_leftSide__DsdQw`,
	"rightSide": `Card_rightSide__QQOC2`,
	"backgroundImage": `Card_backgroundImage__U3mjM`,
	"icon": `Card_icon__PQQjh`,
	"divider": `Card_divider__CbVlc`,
	"title": `Card_title__b9K09`
};
export default ___CSS_LOADER_EXPORT___;
